<template>
  <div>
    <el-dialog
      v-if="show"
      :title="title"
      :visible.sync="show"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
      top="10vh"
      width="880px"
      custom-class="insure-info-dialog"
      center
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="formDom"
        label-width="132px"
        label-position="left"
      >
        <el-row>
          <el-col :span="12"
            ><el-form-item label="单位名称" prop="appliName">
              <el-input
                class="input form-item"
                :disabled="true"
                v-model="form.appliNameHide"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item label="单位类型" prop="appliType">
              <el-select
                class="form-item"
                v-model="form.appliType"
                placeholder="请选择"
                @change="handleSelectAppliType"
              >
                <el-option value="1" label="个人"></el-option>
                <el-option value="2" label="单位"></el-option>
              </el-select> </el-form-item
          ></el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="证件类型" prop="identifyType">
              <el-select
                class="form-item"
                v-model="form.identifyType"
                placeholder="请选择"
              >
                <el-option
                  v-show="Number(form.appliType) === 1"
                  value="01"
                  label="身份证"
                ></el-option>
                <el-option
                  v-show="Number(form.appliType) === 1"
                  value="03"
                  label="护照"
                ></el-option>
                <el-option
                  v-show="Number(form.appliType) === 2"
                  value="70"
                  label="营业执照信用代码"
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="证件号码" prop="identifyNumber">
              <el-input
                class="form-item"
                v-model="form.identifyNumber"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="证件有效期" prop="validDate">
              <el-date-picker
                type="date"
                class="form-item"
                v-model="form.validDate"
                placeholder="年-月-日"
                value-format="yyyy-MM-dd"
                :disabled="longEffective"
                :picker-options="pickerOptions"
              ></el-date-picker>
              <el-checkbox
                v-model="longEffective"
                @change="changeEfficient"
                style="font-weight: 400"
                >长期有效</el-checkbox
              >
            </el-form-item>
          </el-col>
          <el-col :span="12"
            ><el-form-item label="投保人名称" prop="appliName">
              <el-input
                class="input form-item"
                :disabled="true"
                v-model="form.appliName"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="12"
            ><el-form-item label="联系人姓名" prop="linkerName">
              <el-input
                class="form-item"
                v-model="form.linkerName"
                placeholder="请输入"
                disabled
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item label="联系人电话" prop="phoneNumber">
              <el-input
                class="form-item"
                v-model="form.phoneNumber"
                placeholder="请输入"
                disabled
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="经营地址" prop="appliAddress">
              <el-input
                class="form-item"
                v-model="form.appliAddress"
                placeholder="请输入"
                disabled
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item v-if="isPuDong" label="投保机构" prop="comCode">
              <el-select
                class="form-item"
                v-model="form.comCode"
                placeholder="请选择"
                :disabled="!isPuDong"
              >
                <el-option
                  value="31015900"
                  label="太平洋安信农业保险股份有限公司上海浦东支公司"
                  key="comCode1"
                ></el-option>
                <el-option
                  value="31011900"
                  label="太平洋安信农业保险股份有限公司上海南汇支公司"
                  key="comCode2"
                ></el-option>
                <el-option
                  value="31011500"
                  label="太平洋安信农业保险股份有限公司上海临港新片区支公司"
                  key="comCode3"
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              class="accountNameItem"
              label="收款人名称"
              prop="accountName"
            >
              <el-input
                class="form-item"
                v-model="form.accountName"
                placeholder="请输入"
                disabled
              ></el-input>
              <!-- <div style="font-weight: 400; color: #cccccc">
              请输入经营主体的全称
            </div> -->
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="收款银行账号" prop="accountCode">
              <el-input
                class="form-item"
                v-model="form.accountCode"
                placeholder="请输入"
                disabled
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="被保险人证件类型" prop="insuredIdentifyType">
              <el-select
                class="form-item"
                v-model="form.insuredIdentifyType"
                placeholder="请选择"
                disabled
              >
                <el-option value="01" label="身份证"></el-option>
                <el-option value="03" label="护照"></el-option>
                <el-option value="70" label="营业执照信用代码"></el-option>
              </el-select> </el-form-item
          ></el-col>

          <el-col :span="12">
            <el-form-item label="被保险人证件号码" prop="insuredIdentifyNumber">
              <el-input
                class="form-item"
                disabled
                v-model="form.insuredIdentifyNumber"
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="被保人名称">
              <el-input
                class="form-item"
                disabled
                v-model="form.insuredName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="被保险人证件有效止期"
              prop="insuredValidEndDate"
            >
              <el-date-picker
                type="date"
                class="form-item"
                v-model="form.insuredValidEndDate"
                disabled
                placeholder="年-月-日"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="被保险人地址" prop="insuredAddressCName">
              <el-input
                class="form-item"
                disabled
                v-model="form.insuredAddressCName"
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="开户支行" prop="bankBranchName">
              <el-input
                class="form-item"
                v-model="form.bankBranchName"
                disabled
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelHandle">取 消</el-button>
        <el-button type="primary" @click="submitHandle">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validateMixins from "@/views/Insure/Form/validateMixins";
import { getPolicyholderAdd, editPersonInfo } from "@/api/request/snkd.produce";
import { getStorage } from "@/utils/storage";
import { formatDate } from "@/utils";
export default {
  mixins: [validateMixins],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    editInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isPuDong: false, // 是否是浦东新区的农场
      formInfoId: null, // 表单信息回显数据的id
      longEffective: false, // 是否长期有效
      farmId: null,
      companyId: null,
      form: {
        appliName: "",
        appliType: "",
        comCode: null,
        identifyType: "",
        identifyNumber: "",
        validDate: "",
        linkerName: "",
        phoneNumber: "",
        appliAddress: "",
        accountName: "",
        accountCode: "",
        bankName: "",
        bankCode: "",
        bankBranchName: "",
        bankBranchCode: "",
        companyId: null,
        farmId: null,
        insuredIdentifyType: "",
        insuredIdentifyNumber: "",
        insuredValidEndDate: "",
        insuredAddressCName: "",
      },
      policyholderInfo: {},

      pickerOptions: {
        disabledDate(time) {
          // 转换成统一时间格式再比较
          const cur = formatDate(time, "yyyy-MM-dd");
          const now = formatDate(new Date(), "yyyy-MM-dd");
          return new Date(cur).getTime() < new Date(now).getTime();
        },
      },

      title: "新增投保人信息",
    };
  },
  computed: {},
  watch: {
    editInfo(val) {
      this.getPolicyholderInfo(val);
      this.longEffective = false;
    },
    show() {},
  },
  async mounted() {
    this.companyInfo = getStorage("COMPANYINFO");
    this.farmInfo = getStorage("FARMINFO");
    if (this.farmInfo) {
      this.farmId = this.farmInfo.farmId;
      this.companyId = this.farmInfo.companyId;
      this.form.farmId = this.farmInfo.farmId;
      this.form.companyId = this.farmInfo.companyId;
    }

    //   // 单位名称始终拿当前农场名，收款人姓名始终拿当前企业名
    this.form.appliNameHide = this.farmInfo ? this.farmInfo.farmName : "";

    if (this.farmInfo && this.farmInfo.countyId === "310115") {
      this.isPuDong = true;
    }
  },
  methods: {
    //数据回显
    getPolicyholderInfo(info) {
      console.log("info", info);

      this.form = {
        appliNameHide: this.farmInfo ? this.farmInfo.farmName : "",
        appliName: info.appliName, // this.farmInfo ? this.farmInfo.farmName : "",
        appliType: info.appliType || "1",
        comCode: info?.comCode || null,
        identifyType: info.identifyType,
        identifyNumber: info.identifyNumber,
        linkerName: info.linkerName,
        phoneNumber: info.phoneNumber,
        appliAddress: info.appliAddress,
        accountName: info.accountName,
        validDate: info.validDate,
        accountCode: info.accountCode,
        bankName: "",
        bankCode: "",
        bankBranchName: info.bankBranchName,
        bankBranchCode: info.bankBranchCode,
        companyId: info.companyId,
        farmId: this.farmInfo ? this.farmInfo.farmId : "",
        insuredIdentifyType: info.insuredIdentifyType,
        insuredIdentifyNumber: info.insuredIdentifyNumber,
        insuredValidEndDate: info.insuredValidEndDate,
        insuredAddressCName: info.insuredAddressCName,
        insuredName: info.insuredName,
      };
      this.longEffective =
        info.insuredValidEndDate == "2099-01-01" ? true : false;
      this.formInfoId = info.id || null;
    },
    //提交
    submitHandle() {
      this.$refs["formDom"].validate(async (valid) => {
        if (valid) {
          const params = {
            bankBranchCode: this.form.bankBranchCode,
            bankBranchName: this.form.bankBranchName,
            bankCode: this.form.bankCode,
            bankName: this.form.bankName,
            comCode: this.form.comCode,
            companyId: this.companyId,
            farmId: this.farmId,
            appliName: this.form.appliName,
            appliType: this.form.appliType,
            identifyType: this.form.identifyType,
            identifyNumber: this.form.identifyNumber,
            linkerName: this.form.linkerName,
            validDate:
              this.form.validDate == "" && this.longEffective
                ? "2099-01-01"
                : this.form.validDate,
            phoneNumber: this.form.phoneNumber,
            appliAddress: this.form.appliAddress,
            accountName: this.form.accountName,
            accountCode: this.form.accountCode,
            insuredIdentifyType: this.form.insuredIdentifyType,
            insuredIdentifyNumber: this.form.insuredIdentifyNumber,
            insuredValidEndDate: this.form.insuredValidEndDate,
            insuredAddressCName: this.form.insuredAddressCName,
            insuredName: this.form.insuredName,
            id: this.formInfoId,
          };
          try {
            if (this.formInfoId) {
              //编辑
              const res = await editPersonInfo(params);
              if (res.respCode === 0) {
                this.$emit("changeStatus", false);
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.longEffective = false;
                this.title = "编辑投保人信息";
                this.formInfoId = null;
                this.$refs.formDom.resetFields();
                this.branchBankList = [];
              }
            } else {
              //新增
              const res = await getPolicyholderAdd(params);
              if (res.respCode === 0) {
                this.$emit("changeStatus", false);
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                this.longEffective = false;
                this.title = "新增投保人信息";
                this.formInfoId = null;
                this.$refs.formDom.resetFields();
                this.branchBankList = [];
              }
            }
          } catch (e) {
            console.log(e);
          }
        }
      });
    },
    //取消
    cancelHandle() {
      this.$emit("changeStatus", false);
      this.$refs.formDom.resetFields();
      this.branchBankList = [];
      this.longEffective = false;
      this.title = "新增投保人信息";
    },
    changeEfficient(val) {
      if (val) {
        this.form.validDate = "";
      }
    },
    judgeBinding(appliType, identifyType) {
      if (Number(appliType) === 1) {
        // 个人
        return ["01", "03"].includes(identifyType);
      }
      if (Number(appliType) === 2) {
        return identifyType === "70";
      }
    },
    handleSelectAppliType(val) {
      const binding = this.judgeBinding(val, this.form.identifyType);
      if (!binding) {
        this.form.identifyType = "";
        this.form.identifyNumber = "";
      }
    },

    // 判断表单是否全都有初始信息
    judgeFormItem() {
      const formVals = Object.values(this.form);
      const someNoVal = formVals.some((val) => val == null || val === "");
      if (someNoVal) {
        this.$emit("openForm");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-item {
  width: 240px;
}
::v-deep .insure-info-dialog .el-dialog__header {
  background-color: #64c3a4;

  .el-dialog__title {
    color: #fff;
  }
}

::v-deep .el-form-item .el-form-item__label {
  width: 140px !important;
}
::v-deep .el-form-item .el-checkbox {
  margin-left: 8px;
}
</style>
